import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import RecordedClassTable from './RecordedClassTable';
const RecordedClass = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Recorded Class' parent='Recorded Class'  />
      <Container fluid={true}>
        <Row>
          <RecordedClassTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default RecordedClass;
